module.exports = __webpack_public_path__ + "img/newyear.a9bf9e28.png";